<template lang="pug">
  .mRow
    .mRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.no-gutters.flex-nowrap.align-items-start
          .mRow__profileImg.mr-3
          .d-flex.align-items-end.flex-nowrap.no-gutters
            .mRow__content.mRow__videoBox.position-relative.d-flex.align-items-center
              .videoBox__insidevideoBox
                video.w-100.rounded(
                  controls,
                  :poster="this.messageData.previewImage ? this.messageData.previewImage : null"
                )
                  source(
                    :src="this.messageData.preview_url",
                    type="video/mp4"
                  )
                  source(
                    :src="this.messageData.preview_url",
                    type="video/ogg"
                  )
                  | Your browser does not support the video tag.
            .mRow__timeBox
              span(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import defaultPreviewImgUrl from '@/assets/images/default/defaultImg404.png';

export default {
  name: 'M-Video',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      defaultPreviewImg: `this.src="${defaultPreviewImgUrl}"`
    };
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style>

</style>
